import useStyles from './styles';
import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { BackdropLoader } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
import { SubscriptionsTab } from './SubscriptionsTab';

/** Bills page — table markup is still demo data, company/properties come from the API. */
export const BillsPage = observer(() => {
  const classes = useStyles();
  const store = useStore();
  useEffect(() => {
    const loadCompanyProperties = async () => {
      await store.company.getCompanyPropertiesAsync.run({}, []);
    };
    loadCompanyProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isLoading = store.company.getCompanyPropertiesAsync.inProgress;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pageHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "Bills")), /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, /*#__PURE__*/React.createElement(SubscriptionsTab, null)));
});